import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, UserPlus, X, Users } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { people, assigneeOf } from './TrialBoard';

// Owner invites partners and assigns each pending stage; partners see it read-only
export const TrialTeamPanel = ({ s, reload }) => {
  const { api, user } = useAuth();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const owner = s.user_id === user?.id;
  const names = people(s);
  const call = async (fn, ok) => {
    setBusy(true);
    try { await fn(); if (ok) toast.success(ok); await reload(); } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo completar'); } finally { setBusy(false); }
  };
  const invite = () => email.includes('@') && call(() => api.post(`/trial-sim/${s.id}/team`, { email }), 'Socio invitado · le enviamos un correo').then(() => setEmail(''));
  return (
    <div data-testid="trial-team-panel" className="space-y-4">
      <div>
        <p className="flex items-center gap-2 text-sm font-semibold text-white"><Users className="h-4 w-4 text-sky-300" />Equipo de litigio</p>
        <p className="text-xs text-slate-400">Cada socio argumenta solo en las etapas que tiene asignadas. Las etapas sin asignar le tocan al titular.</p>
      </div>
      <ul className="space-y-1.5" data-testid="trial-team-list">
        <li className="rounded-lg border border-slate-800 px-3 py-2 text-xs text-slate-200">{names[s.user_id]} <span className="text-slate-500">· titular</span></li>
        {(s.team || []).map((m) => (
          <li key={m.user_id} data-testid={`trial-member-${m.email}`} className="flex items-center rounded-lg border border-slate-800 px-3 py-2 text-xs text-slate-200">
            {m.name} <span className="ml-1 text-slate-500">· {m.email}</span>
            {owner && <button data-testid={`trial-member-remove-${m.email}`} onClick={() => call(() => api.delete(`/trial-sim/${s.id}/team/${m.user_id}`), 'Socio quitado')} className="ml-auto text-slate-500 hover:text-red-400"><X className="h-3.5 w-3.5" /></button>}
          </li>
        ))}
      </ul>
      {owner && (
        <div className="flex gap-2">
          <input data-testid="trial-invite-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="correo del socio (debe tener cuenta)" className="flex-1 rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-100" />
          <button data-testid="trial-invite-btn" onClick={invite} disabled={busy} className="flex items-center gap-1 rounded-lg bg-sky-500 px-3 text-xs font-semibold text-slate-950 disabled:opacity-60">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <UserPlus className="h-3.5 w-3.5" />}Invitar</button>
        </div>
      )}
      <div data-testid="trial-assignments" className="space-y-1.5">
        <p className="text-xs font-semibold text-slate-300">Quién argumenta cada etapa</p>
        {s.stages.map((st, i) => {
          const editable = owner && s.status === 'running' && i >= s.current && (s.team || []).length > 0;
          return (
            <div key={i} className="flex items-center gap-2 text-xs">
              <span className="min-w-0 flex-1 truncate text-slate-300">{i + 1}. {st.nombre}</span>
              {editable ? (
                <select data-testid={`trial-assign-${i}`} value={assigneeOf(s, i)} disabled={busy} onChange={(e) => call(() => api.put(`/trial-sim/${s.id}/stages/${i}/assignee`, { user_id: e.target.value }))}
                  className="rounded border border-slate-700 bg-slate-900 px-2 py-1 text-slate-100">
                  {Object.entries(names).map(([id, n]) => <option key={id} value={id}>{n}</option>)}
                </select>
              ) : <span data-testid={`trial-assign-label-${i}`} className="text-sky-300">{names[assigneeOf(s, i)]}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
};
